import React, { useCallback, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import GuestsFilterOption from "./FilterOptions/GuestsFilterOption";
import MoreFilters from "./FilterOptions/MoreFilters/MoreFilters";
import classes from "./filterBar.module.scss";
import SrpContainer from "../../containers/SrpContainer";
import { subscribe } from "venuescanner-js/react/helpers";
import FiltersContainer from "./FiltersContainer";
import { FilterContext, SrpContext } from "./context";
import ClearFiltersButton from "./ClearFiltersButton";
import ShowVenuesOrClearFiltersButton from "./ShowVenuesOrClearFiltersButton";
import filtersIcon from "./filters.svg";
import SubPlanFilterOption from "./FilterOptions/SubPlanFilterOption";
import LocationField from "../SrpNav/LocationField";
import EventTypeField from "../SrpNav/EventTypeField";
import RadiusField from "../SrpNav/RadiusField";
import Sort from "../Sort";
import { getUrlForQuery } from "../../helpers/updateUrl";
import Cookies from "js-cookie";

const CloseButton = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={classes.CloseFiltersButton}
  >
    &times;
  </button>
);

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export const FilterBar = ({
  srpContainer,
  filtersContainer,
  isMobileDevice,
}) => {
  const { isAdmin } = srpContainer.state;
  const { mobileFiltersOpen, setMobileFiltersOpen } = useContext(SrpContext);
  const [activeFilter, setActiveFilter] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fieldsWithErrors = filtersContainer.validate(
      srpContainer.state.query
    );
    Cookies.set(
      "search_query",
      encodeURIComponent(getUrlForQuery(srpContainer.state.query)),
      {
        expires: 7,
      }
    );
    setErrors(fieldsWithErrors);
  }, [
    setErrors,
    filtersContainer,
    filtersContainer.state,
    srpContainer.state.query,
  ]);

  const closeFilters = useCallback(
    () => setMobileFiltersOpen(false),
    [setMobileFiltersOpen]
  );
  // console.log('FilterBar')
  return (
    <FilterContext.Provider
      value={{ errors, setErrors, activeFilter, setActiveFilter }}
    >
      <>
        <button
          className={classes.mobileOpenButton}
          onClick={() => setMobileFiltersOpen(true)}
        >
          <svg>
            <use xlinkHref={`${filtersIcon}#filters`} />
          </svg>
          Filters
        </button>
        <div
          className={cl(classes.FilterBar, {
            [classes["FilterBar--mobileOpen"]]: mobileFiltersOpen,
          })}
        >
          <header>
            <CloseButton onClick={closeFilters} />
            <span>Filters</span>
            <ClearFiltersButton then={closeFilters} />
          </header>
          <div>
            <div className={cl(classes.FilterNav)}>
              <span
                className={classes.mobileCloseButton}
                onClick={() => setMobileFiltersOpen(false)}
              />
              <LocationField />
              <div className={cl(classes.RadiusWrapper)}>
                <RadiusField />
              </div>
              <div className={cl(classes.EventTypeWrapper)}>
                <EventTypeField />
              </div>
              <GuestsFilterOption
                error={
                  errors.capacity
                    ? "Please enter your estimated number of guests to search by budget."
                    : undefined
                }
              />
              <MoreFilters isMobileDevice={isMobileDevice} />
              {typeof window !== "undefined" && !isMobileDevice && <Sort />}
            </div>
            <div className={cl(classes.FilterNav)}>
              {isAdmin && <SubPlanFilterOption />}
              <ShowVenuesOrClearFiltersButton then={closeFilters} />
            </div>
          </div>
        </div>
      </>
    </FilterContext.Provider>
  );
};

FilterBar.propTypes = {
  srpContainer: PropTypes.instanceOf(SrpContainer).isRequired,
  filtersContainer: PropTypes.instanceOf(FiltersContainer).isRequired,
};

export default subscribe({ SrpContainer, FiltersContainer })(FilterBar);
